export default __webpack_public_path__ + "static/slider-la-fa8028a36be4f6a67d37d24c8515d2f9.jpg";